function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M456,84H24C10.745,84,0,94.745,0,108v264c0,13.255,10.745,24,24,24h432c13.255,0,24-10.745,24-24V108 C480,94.745,469.255,84,456,84z M464,372c0,4.418-3.582,8-8,8H24c-4.418,0-8-3.582-8-8V108c0-4.418,3.582-8,8-8h432 c4.418,0,8,3.582,8,8V372z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M384,252c-11.453-0.007-22.628,3.522-32,10.104c-25.348-17.721-60.262-11.538-77.983,13.809s-11.538,60.262,13.809,77.983 c19.27,13.472,44.903,13.472,64.173,0c25.348,17.721,60.262,11.538,77.983-13.809c17.721-25.348,11.538-60.262-13.809-77.983 C406.742,255.51,395.508,251.982,384,252z M280,308c-0.051-22.034,17.77-39.937,39.804-39.988c7.096-0.016,14.067,1.86,20.196,5.436 c-16.032,20.245-16.032,48.859,0,69.104c-19.032,11.103-43.461,4.676-54.564-14.356C281.86,322.067,279.984,315.095,280,308z  M384,348c-22.091,0-40-17.909-40-40s17.909-40,40-40s40,17.909,40,40C423.974,330.08,406.08,347.974,384,348z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M40,340h64v16H40V340z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M120,340h72v16h-72V340z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M136,284h104v16H136V284z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M352,220h72v16h-72V220z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M248,220h72v16h-72V220z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M144,220h72v16h-72V220z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M40,220h72v16H40V220z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M128,188v-48c0-8.837-7.163-16-16-16H48c-8.837,0-16,7.163-16,16v48c0,8.837,7.163,16,16,16h64 C120.837,204,128,196.837,128,188z M112,156h-8v-16h8V156z M80,156v-16h8v16H80z M64,140v16H48v-16H64z M48,172h16v16H48V172z  M80,188v-16h32v16H80z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M344,116h96v16h-96V116z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M376,148h64v16h-64V148z"
});

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

var _ref20 = /*#__PURE__*/React.createElement("g", null);

var _ref21 = /*#__PURE__*/React.createElement("g", null);

var _ref22 = /*#__PURE__*/React.createElement("g", null);

var _ref23 = /*#__PURE__*/React.createElement("g", null);

var _ref24 = /*#__PURE__*/React.createElement("g", null);

var _ref25 = /*#__PURE__*/React.createElement("g", null);

var _ref26 = /*#__PURE__*/React.createElement("g", null);

var _ref27 = /*#__PURE__*/React.createElement("g", null);

var _ref28 = /*#__PURE__*/React.createElement("g", null);

var SvgCreditCard = function SvgCreditCard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480 480",
    style: {
      enableBackground: "new 0 0 480 480"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92D7E7"
    },
    d: "M24,92h432c8.837,0,16,7.163,16,16v264c0,8.837-7.163,16-16,16H24c-8.837,0-16-7.163-16-16V108 C8,99.163,15.163,92,24,92z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF1D25"
    },
    cx: 328,
    cy: 308,
    r: 48
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FBB03B"
    },
    cx: 384,
    cy: 308,
    r: 48
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBC17D"
    },
    d: "M72,132h24v32H72V132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C08329"
    },
    d: "M40,164v24c0,4.418,3.582,8,8,8h24v-32H40z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CA974D"
    },
    d: "M72,132H48c-4.418,0-8,3.582-8,8v24h32V132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CA974D"
    },
    d: "M72,164v32h40c4.418,0,8-3.582,8-8v-24H72z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C08329"
    },
    d: "M112,132H96v32h24v-24C120,135.582,116.418,132,112,132z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCreditCard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/creditCard.9ff35605.svg";
export { ForwardRef as ReactComponent };